import React, { useEffect } from "react";
import { Formula } from "../../api";

import { Modal, Form, InputNumber } from "antd";
export default function FormulaModal({
  A,
  B,
  visible,
  data,
  setA,
  setB,
  setVisible,
  type,
}) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        VoltageA: A,
        VoltageB: B,
      });
    }
  }, [visible, A, B, form]);
  const Submit = async () => {
    const { VoltageA, VoltageB } = form.getFieldsValue();
    await Formula.UpdateFormula(data.id, VoltageA, VoltageB, data.type);
    setA(VoltageA);
    setB(VoltageB);
    setVisible(false);
  };
  return (
    <Modal
      title={type + "線性調整"}
      open={visible}
      onCancel={() => setVisible(false)}
      onOk={() => form.submit()}
    >
      <Form form={form} layout="inline" onFinish={Submit}>
        <Form.Item name="VoltageA" label="機具電壓 A">
          <InputNumber />
        </Form.Item>
        <Form.Item name="VoltageB" label="機具電壓 B">
          <InputNumber />
        </Form.Item>
      </Form>
    </Modal>
  );
}
